<div class="panel preview-object">
    <div class="message" trans>No file preview available.</div>
    <button mat-raised-button color="primary" (click)="download.emit()" trans>Download</button>
</div>